import { quickPricerScenarios } from 'v2/actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case quickPricerScenarios.set:
      return action.payload.settings
    default:
      return state
  }
}
